module.exports = __webpack_public_path__ + "img/ic-warning.bd13aab7.svg";